(function ($) {
    var fields = {
        quantity: $('input[name="quantity"]'),
        quantity_sqm: $('input[name="quantity_sqm"]'),
        product_length: $('input[name="product_length"]'),
        product_width: $('input[name="product_width"]'),
        room_length: $('input[name="room_length"]'),
        room_width: $('input[name="room_width"]'),
        calculate: $('#calculateTileCoverage'),
        reset: $('#resetTileCalculator'),
        output_wrap: $('.tile-calculator-output'),
        output_text: $('.tile-calculator-output-number'),
        output_error: $('.tile-calculator-error')
    }

    if (fields.quantity.length) {
        fields.output_wrap.hide();
        fields.quantity.on('change', function () {
            if (parseFloat(fields.product_length.data('orig')) > 0 && parseFloat(fields.product_width.data('orig')) > 0) {
                fields.quantity_sqm.val(
                    Math.round(parseFloat($(this).val()) * (
                        (parseFloat(fields.product_length.data('orig') * parseFloat(fields.product_width.data('orig'))) / 10000))
                        * 100) / 100 // to round to two decimal places - Yaay JS
                );
            }
        });

        fields.quantity_sqm.on('change', function (e) {
            if (parseFloat(fields.product_length.data('orig')) > 0 && parseFloat(fields.product_width.data('orig')) > 0) {
                fields.quantity.val(
                    Math.ceil(parseFloat($(this).val()) / (
                        (parseFloat(fields.product_length.data('orig') * parseFloat(fields.product_width.data('orig'))) / 10000)))
                );
            }
        })

        fields.calculate.on('click', function (e) {
            e.preventDefault();

            fields.output_error.text("");
            fields.output_error.hide();

            var room_sqm = parseFloat(fields.room_width.val()) * parseFloat(fields.room_length.val()) / 10000
            var tile_sqm = parseFloat(fields.product_width.val()) * parseFloat(fields.product_length.val()) / 10000;
            var tile_count = room_sqm / tile_sqm;

            if (isNaN(tile_count)) {
                fields.output_error.text('Please enter valid numbers for your calculation');
                fields.output_error.show();
                return;
            }

            console.log(room_sqm, tile_sqm, tile_count, room_sqm);

            fields.quantity.val(Math.ceil(tile_count));
            fields.quantity_sqm.val(room_sqm);
            fields.output_text.text(Math.ceil(tile_count) + " tiles");
            fields.output_wrap.show();
        })

        fields.reset.on('click', function (e) {
            e.preventDefault();
            fields.output_error.hide();
            fields.output_error.text('');
            fields.room_length.val('');
            fields.room_width.val('');
            fields.product_length.val(fields.product_length.data('orig'));
            fields.product_width.val(fields.product_width.data('orig'));
            fields.output_wrap.hide();
        })

    }
})(jQuery)